"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Escape all regex symbols in a string. Could be used for escaping user input.
 * Escapes: .*+?^${}()|[]\
 * @param str
 * @returns
 */
exports.escapeRegexSymbols = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
//# sourceMappingURL=escape-regex-symbols.utils.js.map